module.exports = __webpack_public_path__ + "img/favorite_icon.f03b81a7.svg";